import { z } from 'zod'

export const DOCUMENT_SOURCES = ['pdf', 'html'] as const

export const documentSourceSchema = z.enum(DOCUMENT_SOURCES)

export type DocumentSource = z.infer<typeof documentSourceSchema>

export const PRISMA_DOCUMENT_SOURCES = ['PDF', 'HTML'] as const

export type PrismaDocumentSource = (typeof PRISMA_DOCUMENT_SOURCES)[number]

export const DOCUMENT_SOURCE_FROM_PRISMA = {
  PDF: 'pdf',
  HTML: 'html',
} as const satisfies Record<PrismaDocumentSource, DocumentSource>

export const DOCUMENT_SOURCE_TO_PRISMA = {
  pdf: 'PDF',
  html: 'HTML',
} as const satisfies Record<DocumentSource, PrismaDocumentSource>
